import { forwardRef } from "react";

import { Link } from "react-router-dom";
import classNames from "classnames";
import { LinkWrapProps, Ref } from "./interface";

const LinkWrap = forwardRef<Ref, LinkWrapProps>(
    (
        {
            url,
            external,
            className,
            featureAttribution,
            children,
            onClick,
            ...rest
        },
        ref
    ) => {
        const classes = classNames(className);

        const noDomainUrl = url?.replace(/^https?:\/\/\S+\.cbc\.ca/g, "") || "";

        const testId = featureAttribution?.instance
            ? `${featureAttribution.instance}-link`
            : "";

        return external ? (
            <a
                ref={ref as React.Ref<HTMLAnchorElement>}
                href={url || ""}
                className={classes}
                data-feature-instance={featureAttribution?.instance}
                data-feature-name={featureAttribution?.name}
                data-feature-position={featureAttribution?.position}
                data-testid={testId}
                {...rest}
            >
                {children}
            </a>
        ) : (
            <Link
                ref={ref as React.Ref<HTMLAnchorElement>}
                to={noDomainUrl}
                className={classes}
                data-feature-instance={featureAttribution?.instance}
                data-feature-name={featureAttribution?.name}
                data-feature-position={featureAttribution?.position}
                data-testid={testId}
                onClick={onClick}
                {...rest}
            >
                {children}
            </Link>
        );
    }
);

LinkWrap.displayName = "LinkWrap";

export default LinkWrap;
